"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EFormsStatusTracking_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var EFormsStatusTracking_Factory = /** @class */ (function () {
    function EFormsStatusTracking_Factory() {
    }
    EFormsStatusTracking_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            CompletedBy: model.CompletedBy,
            InstanceId: model.InstanceId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            StatusCode: model.StatusCode,
        };
        return result;
    };
    EFormsStatusTracking_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            CompletedBy: model.CompletedBy,
            InstanceId: model.InstanceId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            StatusCode: model.StatusCode,
        };
        return result;
    };
    return EFormsStatusTracking_Factory;
}());
exports.EFormsStatusTracking_Factory = EFormsStatusTracking_Factory;
